import React, { FC } from 'react'
import Head from 'next/head'
import { Region } from '@moonpig/web-core-types'
import { useFindLocaleText } from '../../text-localisation'
import { buildSearchTitle } from '../../utils/buildSearchTitle'

type SearchHeadProps = {
  region: Region
  page: number
}

export const SearchHead: FC<SearchHeadProps> = ({ region, page }) => {
  const localiseText = useFindLocaleText()
  const canonicalUrl = `${process.env.HOST_URL}/${region}/search/`

  const dynamicTitle = buildSearchTitle(
    localiseText('find.search_results'),
    page,
    localiseText('find.page'),
  )

  return (
    <Head>
      <title>{dynamicTitle}</title>
      <meta name="title" content={dynamicTitle} />
      <meta name="description" content="Search Results" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content="Search Results" />
      <meta property="og:description" content="Search Results" />
      <meta property="og:locale" content="en-GB" />
      <meta property="og:type" content="website" />
      <meta data-testid="robots" name="robots" content="noindex, nofollow" />
    </Head>
  )
}
